import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const PLANS = [
  { id: 'gratuito', label: 'Gratuito', price: 'Grátis', limit: '10 cupons/mês', features: ['10 cupons por mês', 'Acesso básico', 'Suporte básico'] },
  { id: 'premium', label: 'Premium', price: 'R$ 150', limit: '30 cupons/mês', features: ['30 cupons/mês', 'Painel do Lojista', 'Suporte WhatsApp em até 24h'] },
  { id: 'platinum', label: 'Platinum', price: 'R$ 300', limit: '50 cupons/mês', features: ['50 cupons/mês', 'Painel do Lojista', 'Suporte WhatsApp Admin', '1 ANÚNCIO POR CATEGORIA'] },
  { id: 'black', label: 'Black', price: 'R$ 750', limit: '80 cupons/mês', features: ['80 cupons/mês', 'Painel do Lojista', 'Suporte WhatsApp Admin', '2 ANÚNCIOS POR CATEGORIA'] },
];

export const LandingPlans = ({ onLogin }) => (
  <section className="py-16 md:py-20 bg-slate-100" data-testid="plans-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">Planos para Lojistas</h2>
        <p className="text-base text-slate-600 max-w-2xl mx-auto">Escolha o plano ideal para o seu negócio. Pagamento mensal recorrente no cartão.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {PLANS.map(plan => (
          <Card key={plan.id} className={`bg-white border-2 transition-all hover:shadow-lg ${plan.id === 'black' ? 'border-slate-900 shadow-lg' : plan.id === 'platinum' ? 'border-slate-400' : 'border-slate-200'}`}
            data-testid={`plan-card-${plan.id}`}>
            <CardContent className="pt-6">
              {plan.id === 'platinum' && <Badge className="bg-slate-900 text-white border-0 text-xs mb-2">Mais Popular</Badge>}
              <h3 className="text-xl font-bold text-slate-900 mb-1">{plan.label}</h3>
              <p className="text-3xl font-black text-slate-900 mb-1">{plan.price}<span className="text-sm font-normal text-slate-500">/mês</span></p>
              <p className="text-sm text-slate-500 mb-4">{plan.limit}</p>
              <ul className="space-y-2 mb-4">
                {plan.features.map((f, i) => (
                  <li key={`plan-li-${i}`} className="text-sm text-slate-600 flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-500 shrink-0" /> {f}
                  </li>
                ))}
              </ul>
              <Button onClick={onLogin}
                className={`w-full font-bold ${plan.id === 'black' ? 'bg-slate-900 hover:bg-slate-800' : 'bg-amber-500 hover:bg-amber-600'} text-white rounded-lg`}
                data-testid={`plan-select-${plan.id}`}>
                {plan.id === 'gratuito' ? 'Começar Grátis' : 'Assinar Agora'}
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-center text-sm text-slate-500 italic" data-testid="influencer-key-notice">
        Caso tenha chave exclusiva de Influenciador, ative diretamente no plano escolhido.
      </p>
    </div>
  </section>
);
